import React from 'react'
import ClosureSurvey from 'sprockets_react/closure_survey/registry'
import ClosureSurveyData from 'sprockets_react/closure_survey/data/registry'

ClosureSurvey.WhoDidTheJob = {
  onSubmit: function(onStepProgression, onRequest, onRequestCompletion) {
    this.validator.validateField('provider_account_id')
    this.validator.isValidField('provider_account_id') && onStepProgression()
  },

  onLeftNavButtonClick(onStepProgression) {
    ClosureSurvey.Emitter.emit('closureSurvey:wizard:advanceToStep', ClosureSurvey.HasJobBeenDoneYet)
  },

  buttonLayout: function(trigger) {
    return (trigger === 'my_listings' ? 'nextButton' : 'default')
  },

  component: React.createClass({
    componentDidMount: function() {
      const closureData = ClosureSurveyData.Data

      if (closureData.providerAccountId !== null && (this.props.trigger === 'hire_button' || this.props.trigger === "leave_feedback_button") && closureData.outcome === 'job_completed') {
          ClosureSurvey.Emitter.emit('closureSurvey:wizard:advanceToStep', ClosureSurvey.RateExperience)
      }

      $('#job-closure-modal').bootstrapValidator({})
      ClosureSurvey.WhoDidTheJob.validator = $('#job-closure-modal').data('bootstrapValidator')

      $('#business-radio-group').radioButtonGroup({activeRowClass: 'active'})

      this.setupValidation()
    },

    setupValidation: function() {
      ClosureSurvey.WhoDidTheJob.validator.addField('provider_account_id',
        { validators: {
            notEmpty: {
              message: 'Please select an answer'
            },
            blank: {}
          }
        }
      )
    },

    autoProgressSelectedBusiness: function(e, businessName) {
      const outcome = ClosureSurveyData.Data.outcome
      const $selectedItem = $(e.currentTarget).find('[type="radio"]')[0]

      ClosureSurveyData.Actions.resetData()
      ClosureSurveyData.Data.providerAccountId = $selectedItem.value
      ClosureSurveyData.Data.providerAccountName = businessName
      ClosureSurveyData.Data.outcome = outcome

      if (ClosureSurveyData.Data.outcome === "going_ahead") {
        ClosureSurvey.Emitter.emit('closureSurvey:wizard:advanceToStep', ClosureSurvey.SubmitFeedback)
      }
      else {
        ClosureSurvey.Emitter.emit('closureSurvey:wizard:advanceToStep', ClosureSurvey.RateExperience)
      }
    },

    autoProgressOtherOptions: function(e) {
      const $selectedItem = $(e.currentTarget).find('[type="radio"]')[0]

      ClosureSurveyData.Actions.resetData()
      ClosureSurveyData.Data.outcome = $selectedItem.value
      ClosureSurvey.Emitter.emit('closureSurvey:wizard:advanceToStep', ClosureSurvey.SubmitFeedback)
    },

    render: function() {
      return (
        <div>
          <h3 className="mb15 mt20">{ClosureSurveyData.Data.outcome === "going_ahead" ? "Have you chosen a business to do the work?" : "Who did the job?"}</h3>
          <div className="form-group">
            <div className="radio-button-box minor-bold" id="business-radio-group">
              { this.props.possibleBusinesses.map((business) => {
                  return (
                    <div key={business.id} className="radio" onClick={(e) => this.autoProgressSelectedBusiness(e, business.business_name)}>
                      <div className="row">
                        <div className="col-xs-10 col-sm-10 bold">{business.user_name} from {business.business_name}</div>
                        <div className="col-xs-10 col-sm-10 font-12">{business.mobile_phone}</div>
                        <input type="radio" id={business.id} name="provider_account_id" value={business.id} className="form-control invisible"/>
                      </div>
                    </div>
                  )
                })
              }
            </div>
            { ClosureSurveyData.Data.outcome === "going_ahead" &&
              <div className="radio-button-box minor-bold pt30" id="outcome-radio-group">
                <div className="radio radius-6" onClick={this.autoProgressOtherOptions}>
                  <div className="row">
                    <div className="col-xs-10 col-sm-10 bold">I'm still deciding who to hire</div>
                    <input type="radio" id="going_ahead" name="outcome" value="going_ahead" className="form-control invisible"/>
                  </div>
                </div>
              </div>
            }
            <div className="radio-button-box minor-bold pt30" id="outcome-radio-group">
              <div className="radio radius-6" onClick={this.autoProgressOtherOptions}>
                <div className="row">
                  <div className="col-xs-10 col-sm-10 bold">A business from outside ServiceSeeking.com.au</div>
                  <input type="radio" id="job_completed_externally" name="outcome" value="job_completed_externally" className="form-control invisible"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  })
}

